class SliderVideo extends HTMLElement { 
    constructor() {
        super();
        this.addEventListener('click', this.toggleVideo.bind(this));
        this.initIntersectionObserver();
    }

    initIntersectionObserver() {
        const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                const video = entry.target.querySelector('video');
                const playerIcon = entry.target.querySelector('.player_icon');
                if (!entry.isIntersecting) {
                    video.pause();
                    // video.currentTime = 0; // Optionally reset video to start
                    playerIcon.classList.remove('invisible');
                }
            });
        }, { threshold: 0.5 });

        observer.observe(this);
    }

    toggleVideo() {
        const video = this.querySelector('video');
        const playerIcon = this.querySelector('.player_icon');

        const allVideos = document.querySelectorAll('slider__video video');
        allVideos.forEach(otherVideo => {
            if (otherVideo !== video && !otherVideo.paused) {
                otherVideo.pause();
            }
        });
        
        if (video.paused) {
            video.play();
            playerIcon.classList.add('invisible'); // Hide the icon
        } else {
            video.pause();
            playerIcon.classList.remove('invisible'); // Show the icon
        }
    }
}

customElements.define('slider-video', SliderVideo);